<design-slide-up-card [isCardOpen]="!!isCardOpen" class="filters-form overflow-y-auto" [title]="filteringAndSortingText"
  [roleDialog]="true" [icon]="arrowIconName" [focusInitialOnHeaderBack]="true" (onHeaderButtonClick)="onHeaderClose()" [displayBackground]="true">
  <mot-button icon="redo" buttonClass="!border-solid !border !border-[#B4BFCB] !rounded-xl" iconClass="!text-2xl" textClass="text-[#0C3058]" headerItem
    [text]="clearFiltersText" (onClick)="resetFilters()" />

  <form [formGroup]="filtersForm" class="flex flex-col gap-6 h-full min-h-full">
    <div class="flex flex-1 flex-col px-4 gap-2">
      <app-filter-section [title]="sortByText">
        <mot-radio-button formControlName="sortBy" [options]="sortOptions"
          class="flex flex-col text-base"></mot-radio-button>
      </app-filter-section>

      <app-filter-section [title]="transportMethodsText">
        <mot-multi-checkbox formControlName="transportations" class="flex flex-col justify-start"
          toggleClass="w-44 h-10 text-base" iconClass="text-2xl" selectAllIcon="taxi-bus"
          [options]="transportationOptions$"></mot-multi-checkbox>
      </app-filter-section>

      <app-filter-section [title]="accessibllityText">
        <mot-checkbox formControlName="isAccessible" [label]="showAccessibleTransportText" class="text-base"
          icon="wheelchair-move" />
      </app-filter-section>

      <app-filter-section [title]="changesText" class="w-full">
        <mot-button-toggle [options]="changesOptions" formControlName="changes" class="!rounded-lg w-full"
          toggleClass="px-4 flex-1" [groupAriaLabel]="changesText" />
      </app-filter-section>

      <app-filter-section [title]="maxTravelTimeText" [showValue]="true"
        [value]="getFormControl('maxTravelTime').value" [max]="maxTravelTimeValue"
        (valueChange)="getFormControl('maxTravelTime').setValue($event)">
        <mot-slider formControlName="maxTravelTime" class="!w-full !m-0" inputClass="!w-full"
          [max]="maxTravelTimeValue" [thumbLabel]="false" [label]="maxTravelTimeText"></mot-slider>
      </app-filter-section>

      <app-filter-section [title]="maxWalkingTimeText" [addDivider]="false" [showValue]="true"
        [value]="getFormControl('maxWalkTime').value" [max]="maxWalkingTimeValue"
        (valueChange)="getFormControl('maxWalkTime').setValue($event)">
        <mot-slider formControlName="maxWalkTime" class="!w-full !m-0" inputClass="!w-full"
          [max]="maxWalkingTimeValue" [thumbLabel]="false" [label]="maxWalkingTimeText"></mot-slider>
      </app-filter-section>
    </div>

    <div class="sticky bottom-0 py-4 flex flex-col gap-2 z-50 bg-white px-4">
      <mot-button buttonClass="!bg-primary w-full !text-white !py-6 !rounded-lg !align-middle" [text]="applyFiltersText"
        (onClick)="applyFilters()" />

      <mot-button 
        buttonClass="!bg-transparent w-full !py-6 !rounded-lg !border !border-solid !border-gray-400 !align-middle"
        [text]="applyAndSaveText" (onClick)="applyFilters(true); " />
    </div>
  </form>
</design-slide-up-card>
